module.exports = __webpack_public_path__ + "static/scale-model-of-knoxville-food-tours-in-knoxville-tennessee-dbcb1fb350611a2f31271fdcf08c54da.png";